/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ErrorResponse, MatomoConfigDTO } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class ConfigApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags config-api
   * @name GetEnvironmentName
   * @request GET:/api/config/environment-name
   * @secure
   */
  getEnvironmentName = (params: RequestParams = {}) =>
    this.request<string, ErrorResponse>({
      path: `/api/config/environment-name`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags config-api
   * @name GetMatomoConfig
   * @request GET:/api/config/matomo-config
   * @secure
   */
  getMatomoConfig = (params: RequestParams = {}) =>
    this.request<MatomoConfigDTO, ErrorResponse>({
      path: `/api/config/matomo-config`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags config-api
   * @name GetRecaptchaKey
   * @request GET:/api/config/recaptcha-key
   * @secure
   */
  getRecaptchaKey = (params: RequestParams = {}) =>
    this.request<string, ErrorResponse>({
      path: `/api/config/recaptcha-key`,
      method: "GET",
      secure: true,
      ...params,
    });
}
